import React from "react";
import { FaThumbsUp } from "react-icons/fa";
import {
  FEED_SOURCE_FILTERS,
  FEED_FILTERS,
  isFeedSourceFilterActive,
} from "../../pages/feed/feedConstants";
import styles from "../../styles/pages/feed/FeedPage.module.css";

const FeedMobileFilters = ({
  activeFilter,
  activeTab,
  showingMatches,
  showingBattles,
  showingFlex,
  showingAsk,
  onFeedSourceClick,
  onFeedTab,
}) => (
  <div className={styles.mobileFilters}>
      {FEED_SOURCE_FILTERS.map((f) => {
        const Icon = f.icon;
        const isActive = isFeedSourceFilterActive(
          f.id,
          activeFilter,
          activeTab,
          showingMatches,
        );
        return (
          <button
            key={f.id}
            type="button"
            className={`${styles.mobileFilterChip} ${
              isActive ? styles.mobileFilterChipActive : ""
            }`}
            onClick={() => onFeedSourceClick(f.id)}
            title={f.title}
            aria-pressed={isActive}
          >
            <Icon aria-hidden="true" />
            <span>{f.label}</span>
          </button>
        );
      })}
      <button
        type="button"
        className={`${styles.mobileFilterChip} ${
          showingMatches ? styles.mobileFilterChipActive : ""
        }`}
        onClick={() => onFeedTab("matches")}
        aria-pressed={showingMatches}
      >
        <FaThumbsUp aria-hidden="true" />
        <span>My matches</span>
      </button>
      {FEED_FILTERS.map((f) => {
        const Icon = f.icon;
        const isActive = f.isBattles
          ? showingBattles
          : f.isFlex
            ? showingFlex
            : showingAsk;
        return (
          <button
            key={f.id}
            type="button"
            className={`${styles.mobileFilterChip} ${
              isActive ? styles.mobileFilterChipActive : ""
            } ${f.isBattles ? styles.mobileFilterChipBattle : ""}`}
            onClick={() => onFeedTab(f.id)}
            aria-pressed={isActive}
          >
            <Icon aria-hidden="true" />
            <span>{f.label}</span>
          </button>
        );
      })}
    </div>
);

export default React.memo(FeedMobileFilters);
